var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m14.974 9.005-.784-2.616-1.552-5.19a.3.3 0 0 0-.098-.144.254.254 0 0 0-.314 0 .3.3 0 0 0-.097.144l-1.552 5.186H5.421L3.869 1.2a.3.3 0 0 0-.098-.144A.25.25 0 0 0 3.615 1a.25.25 0 0 0-.157.055.3.3 0 0 0-.098.144L1.81 6.385l-.783 2.62a.63.63 0 0 0 0 .358.6.6 0 0 0 .193.29L8 15l6.778-5.347a.6.6 0 0 0 .195-.29.63.63 0 0 0 .001-.358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m8 14.998 2.578-8.611H5.423z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M8 14.998 5.42 6.387H1.813z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m1.81 6.387-.784 2.616a.63.63 0 0 0 0 .358.6.6 0 0 0 .193.29L8 14.999z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M1.812 6.389h3.612L3.87 1.203a.3.3 0 0 0-.097-.144.254.254 0 0 0-.314 0 .3.3 0 0 0-.097.144L1.81 6.389Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m8 14.998 2.578-8.611h3.614z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m14.19 6.387.784 2.616a.63.63 0 0 1 0 .358.6.6 0 0 1-.194.29L8 14.995l6.188-8.608h.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M14.19 6.389h-3.61l1.551-5.186a.3.3 0 0 1 .098-.144.254.254 0 0 1 .313 0q.07.056.098.144l1.552 5.186Z"
  })));
});